import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App.tsx';
import { AppErrorBoundary } from './components/common/AppErrorBoundary';
import './index.css';
import { env } from './config/env';
import { watchSessionSwitches } from './lib/session-caches';

// Before the first render: every entry into or out of a support session has to
// find the session-scoped caches already wired, including one restored from
// localStorage on this very load.
watchSessionSwitches();

createRoot(document.getElementById('root')!).render(
  <AppErrorBoundary>
    <GoogleOAuthProvider clientId={env.GOOGLE_OAUTH_CLIENT_ID} locale="es">
      <App />
    </GoogleOAuthProvider>
  </AppErrorBoundary>,
);
